export default "__VITE_ASSET__DD8KfLU0__"